import * as t from 'io-ts';
import { authorizedTo, entityType, id, users } from '@/services/api';

const entityItem = t.type({
  id,
  title: t.string,
});

const label = t.type({
  id,
  label: t.string,
});

const simpleEntityFolder = t.type({
  id,
  title: t.string,
});

const data = t.type({
  title: t.string,
  users,
  parents: t.array(simpleEntityFolder),
  labels: t.array(label),
  children: t.array(simpleEntityFolder),
  entityItems: t.array(entityItem),
});

const listEntityItemData = t.type({
  title: t.string,
  entityType: t.union([entityType, t.null]),
  users,
});

export const listEntityItem = t.type({
  id,
  data: listEntityItemData,
});

const listData = t.type({
  title: t.string,
  path: t.array(t.number),
  users,
  labels: t.array(label),
  entityItems: t.array(listEntityItem),
});

export const recordCodec = t.type({
  id,
  data,
  authorizedTo,
});

export const listRecordCodec = t.type({
  id,
  data: listData,
  authorizedTo,
});

export const listCodec = t.type({
  data: t.array(listRecordCodec),
});

export const formEditCodec = t.type({
  title: t.string,
  entityItems: t.array(t.number),
  users: t.array(t.number),
  children: t.array(t.number),
  labels: t.array(t.string),
  parents: t.array(t.number),
});

export const formCodec = t.type({
  title: t.string,
  entityItems: t.array(t.number),
  users: t.array(t.number),
  children: t.array(t.number),
  labels: t.array(t.string),
  parents: t.array(t.number),
});
